import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Subject } from 'rxjs';

@Injectable()
export class MatPaginatorIntlLocalizedService implements MatPaginatorIntl {
  changes = new Subject<void>();
  firstPageLabel = $localize`Начална страница`;
  itemsPerPageLabel = $localize`Редове:`;
  lastPageLabel = $localize`Последна страница`;
  nextPageLabel = 'Следваща страница';
  previousPageLabel = 'Предишна страница';

  getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0) {
      return $localize`Страница 0 от 0`;
    }
    const startIndex = page * pageSize;
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;
    return $localize`${startIndex + 1} – ${endIndex} от ${length}`;
  }
}
